export class ClientStatisticsByMonthRequest {
    constructor(
        public clientId: string,
        public startDate: Date,
        public endDate: Date,
    ) { }
}